import getSnippetInstance from '../zend-desk/get-snippet-instance';

const closeForm = async () => {
  const widget = await getSnippetInstance();
  widget.close();
};

export default closeForm;
